import { NsStandout } from '@britishgasenergy/react-nucleus';

import { PAYMENT_NAMES, PAYMENT_METHODS, FUEL_TYPES } from 'config/app-config';

export const prepayOnlyMessageTestId = 'prepayOnlyMessageTestId';

export type Props = {
  fuelType: {
    [FUEL_TYPES.ELECTRIC]: boolean;
    [FUEL_TYPES.GAS]: boolean;
  };
  shouldShow?: boolean;
};

export const PrepayOnlyMessage = ({ fuelType, shouldShow }: Props) => {
  const gasOnly = !fuelType.electric && fuelType.gas;
  const electricOnly = fuelType.electric && !fuelType.gas;
  const dualFuel = fuelType.electric && fuelType.gas;
  const paymentMethodName = PAYMENT_NAMES[PAYMENT_METHODS.PREPAY].toLowerCase();
  let fuelName = '';

  switch (true) {
    case gasOnly:
      fuelName = 'gas';
      break;
    case electricOnly:
      fuelName = 'electricity';
      break;
    default:
      fuelName = 'energy';
      break;
  }

  if (!shouldShow) {
    return null;
  }

  return (
    <div data-testid={prepayOnlyMessageTestId}>
      <NsStandout decoration="orange">
        <h3 data-testid="title">
          Good news - we’ve got a {paymentMethodName} option for your {fuelName}
        </h3>

        {dualFuel && (
          <>
            <p data-testid="dual-fuel">
              We’ve noticed that your address has {paymentMethodName} meters.
              So, you&apos;ll need to top up your key or card at the Post Office
              or Payzone location.
            </p>
            <p>
              Once your gas and electricity supply is up and running, we can
              look into switching to Direct Debit if that’s something you’re
              interested in.
            </p>
          </>
        )}

        {!dualFuel && (
          <>
            <p data-testid="single-fuel">
              We’ve noticed that your address has a {paymentMethodName}{' '}
              {fuelName} meter. So, you&apos;ll need to top up your key or card
              at the Post Office or Payzone location.
            </p>
            <p>
              Once your {fuelName} supply is up and running, we can look into
              switching to Direct Debit if that’s something you’re interested
              in.
            </p>
          </>
        )}
      </NsStandout>
    </div>
  );
};
